export default "__VITE_ASSET__dae3d330__"